module.exports = publishpressFutureBlockEditorConfig;